import { render } from "./sbLeftAd.vue?vue&type=template&id=533f9e01&scoped=true"
import script from "./sbLeftAd.vue?vue&type=script&lang=js"
export * from "./sbLeftAd.vue?vue&type=script&lang=js"

import "./sbLeftAd.vue?vue&type=style&index=0&id=533f9e01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533f9e01"]])

export default __exports__